import { render, staticRenderFns } from "./communityDetail.vue?vue&type=template&id=1dcc7120&"
import script from "./communityDetail.vue?vue&type=script&lang=js&"
export * from "./communityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports